import React from 'react'


import './about-us.css';
export default function About () {
    return (
        <>
            <section className="section" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="center-heading">
                                <h2>Who are<em> We</em></h2>
                                <p>Multitasker is an online marketplace that connects busy everyday people who need to outsource any task or run any errand with trusted local multitaskers who are ready to work and lend a helping hand. From weird and quirky, simple to complicated task, we can help you complete your residential, commercial or personal needs. Need a tradesman, cleaning service, handyman, marketing and design, admin services, furniture assembled, trucker, photographer, organiser, or someone to run an errand multitasker is here for you. Our commitment to our customers is to make sure they are happy when the task is completed. Our commitment to our taskers is to make sure they are paid in full for their skills and passions.

</p>
<div className="about-quality">
    <div className="quality-1">
<img src="https://cdn-icons-png.flaticon.com/512/3699/3699516.png" width="50"/>
&nbsp;Safe & secure payments
    </div>
    <div className="quality-1">
    <img src="https://cdn-icons-png.flaticon.com/512/3699/3699516.png" width="50"/>
    &nbsp;Best for all budgets
    </div><div className="quality-1">
    <img src="https://cdn-icons-png.flaticon.com/512/3699/3699516.png" width="50"/>
    &nbsp;Find the right tasker for the job
</div>
    <div className="quality-1">
<img src="https://cdn-icons-png.flaticon.com/512/3699/3699516.png" width="50"/>
&nbsp;Communicate easily with live chat
    </div>
</div>
                            </div>

                        </div>
                    </div>

                </div>
            </section>
        </>
    )

}